import { useAuth } from '../context/AuthContext';
import { BACKEND_ENABLED } from '../config';
import Logo from './Logo';

const STORES = [
  { key: 'coles',              label: 'Coles',              color: '#E50016' },
  { key: 'woolworths',         label: 'Woolworths',         color: '#129C4F' },
  { key: 'aldi',               label: 'Aldi',               color: '#001E5E' },
  { key: 'chemist-warehouse',  label: 'Chemist Warehouse',  color: '#E30019' },
];

function Header({ activeTab, onTabChange, onRefresh, onRefreshStore, scraping, lastUpdated, onSignIn, favOnSaleCount = 0 }) {
  const { user } = useAuth();
  // Deals/Compare work off a static snapshot, so they're always available.
  // Only account-dependent tabs need the backend turned on.
  const tabs = [
    'Deals',
    ...(BACKEND_ENABLED && user ? ['For You'] : []),
    'Shopping List',
    'Compare',
    ...(BACKEND_ENABLED && user ? ['Favourites', 'Profile'] : []),
    ...(BACKEND_ENABLED && user?.isAdmin ? ['Admin'] : []),
  ];

  function formatUpdated(iso) {
    if (!iso) return 'Never';
    return new Date(iso).toLocaleString('en-AU', {
      weekday: 'short', day: 'numeric', month: 'short',
      hour: '2-digit', minute: '2-digit',
    });
  }

  const postcodeWarning = user && !user.postcode && activeTab === 'Deals';

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-brand">
          <Logo variant="full" theme="light" height={48} />
        </div>
        <div className="header-actions">
          {lastUpdated && (
            <span className="header-updated">Updated {formatUpdated(lastUpdated)}</span>
          )}
          {user?.isAdmin && (
            <button
              className={`btn-refresh ${scraping ? 'btn-refresh--loading' : ''}`}
              onClick={onRefresh}
              disabled={scraping}
            >
              {scraping ? 'Scraping…' : 'Refresh Deals'}
            </button>
          )}
          {BACKEND_ENABLED && (user ? (
            <button
              className="btn-avatar"
              onClick={() => onTabChange('Profile')}
              title={user.name || user.email}
            >
              {(user.name || user.email)[0].toUpperCase()}
            </button>
          ) : (
            <button className="btn-signin" onClick={onSignIn}>
              Sign in
            </button>
          ))}
        </div>
      </div>

      {user?.isAdmin && (
        <div className="header-store-btns">
          {STORES.map(({ key, label, color }) => (
            <button
              key={key}
              className="btn-store-scrape"
              style={{ '--store-color': color }}
              onClick={() => key === 'aldi' ? onTabChange('Admin') : onRefreshStore(key)}
              disabled={key !== 'aldi' && scraping}
              title={key === 'aldi' ? 'Upload Aldi screenshot' : `Scrape ${label} only`}
            >
              {key === 'aldi' ? 'Aldi 📷' : label}
            </button>
          ))}
        </div>
      )}

      {postcodeWarning && (
        <div className="header-postcode-tip">
          <span>📍 Set your postcode in</span>
          <button onClick={() => onTabChange('Profile')}>Profile</button>
          <span>for accurate Woolworths &amp; Aldi deals</span>
        </div>
      )}

      <nav className="header-nav">
        {tabs.map(tab => (
          <button
            key={tab}
            className={`nav-tab ${activeTab === tab ? 'nav-tab--active' : ''}`}
            onClick={() => onTabChange(tab)}
          >
            {tab}
            {tab === 'Favourites' && favOnSaleCount > 0 && (
              <span className="nav-tab-badge">{favOnSaleCount}</span>
            )}
          </button>
        ))}
      </nav>
    </header>
  );
}

export default Header;
